// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/uber.

import { useBackend } from '../useBackend'

/** POST /api/uber/getUberReportChecks */
export function useGetUberReportChecks<T = any>() {
  return useBackend<T>('uber/getUberReportChecks')
}

/** POST /api/uber/processUberReportUpload */
export function useProcessUberReportUpload<T = any>() {
  return useBackend<T>('uber/processUberReportUpload')
}

/** POST /api/uber/rereadUberReportDay */
export function useRereadUberReportDay<T = any>() {
  return useBackend<T>('uber/rereadUberReportDay')
}

/** POST /api/uber/signUberReportUpload */
export function useSignUberReportUpload<T = any>() {
  return useBackend<T>('uber/signUberReportUpload')
}
